module.exports = {
      id: "sharechat-usage",
      viewBox: "0 0 29.14 29.14",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#sharechat",
      toString: function () {
        return this.url;
      }
    }